// extracted by mini-css-extract-plugin
module.exports = {"textStyle":"SlideNumber_textStyle__1P_um"};